import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, withModifiers as _withModifiers, isRef as _isRef, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-9bb8f08c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "form" }
const _hoisted_2 = { class: "g-fw7 text-primary" }
const _hoisted_3 = { class: "text-primary" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_5 = { class: "g-fw7" }
const _hoisted_6 = { class: "text-primary" }
const _hoisted_7 = { class: "text-primary text-center" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_9 = { class: "g-fw7" }

import { ref, reactive, onMounted, computed, watch } from 'vue';
import {
	postStudentSubjectInfo,
	postStudentSubjectSave,
	postStudentSubjectList,
	SubjectItemType,
	positionItemType,
	postBasePositionList,
} from '@/api/request/user';
import { getDictList, dictItemType } from '@/api/request';
import { FormRules, FormInstance, ElMessage, ElMessageBox } from 'element-plus';
import { postBaseSiteInfo } from '@/api/request/user';
import store from '@/store';
import router from '@/router';
import { useI18n } from 'vue-i18n';
import { useRoute } from 'vue-router';


export default /*#__PURE__*/_defineComponent({
  __name: 'MobileUserSelect',
  setup(__props) {

// import store from "@/store";
// import { onMounted, computed, ref } from "vue";
// import { postBaseEditStudentType } from "@/api/request/user";
// import { ElMessage } from "element-plus";
// import dlIcon from '@/assets/operate/userSelect/dlIcon.png'

const { t } = useI18n();

//志成添加
const route = useRoute();
//end----

const dutyList = ref([] as positionItemType[]);
const dutyStr = ref('');

const agent_improve_info_tips = ref('');
const subjectStr = ref('');
onMounted(() => {
	postBaseSiteInfo({ type: 'agent_improve_info_tips' }).then((res) => {
		if (res.data['agent_improve_info_tips'])
			agent_improve_info_tips.value = JSON.parse(res.data['agent_improve_info_tips']).data.replace(/\n/g, '<br/>');
	});
	// getDictList({ type: "agent_job_list" }).then((res) => {
	//   dutyList.value = res.data;
	//   // dutyList.value.push({
	//   //   label: t("其他"),
	//   //   value: "-1",
	//   //   businessId: "-1",
	//   // });
	// });
	postBasePositionList().then((res) => {
		dutyList.value = res.data;
	});
	getDictList({ type: 'subject_catagory' }).then((res) => {
		catagoryList.value = res.data;
	});
});
const subjectList = ref([] as SubjectItemType[]);
const subjectListSEA = ref([] as SubjectItemType[]);
const catagoryList = ref([] as dictItemType[]);
// const userInfo = computed(() => {
//   return store.state.user.userInfo;
// });
// const isChangeLevel = ref(false);
// const $emits = defineEmits(["reload"]);
const num = ref(5);
// onMounted(() => {
//   // 品牌方 有主体 展示无权限
//   // 品牌方 无主体 展示账号升级
//   // 代理商 无主体 展示账号升级
//   postStudentSubjectInfo().then((res) => {
//     if (!res.data) {
//       remoteMethod("");
//     } else {
//       queryForm.value.duty = res.data.duty;
//       queryForm.value.subjectId = res.data.subjectName;
//       queryForm.value.studentName = res.data.studentName;
//       queryForm.value.email = res.data.email;
//       num.value = res.data.num as number;
//       isEdit.value = false;
//     }
//   });
// });
const isUseType = ref(false);
const dutyArr = ref([] as string[]);
watch(
	() => store.state.user.infoPerfectDialog,
	() => {
		if (store.state.user.infoPerfectDialog) {
			num.value = store.state.user.userInfo.num;
			postStudentSubjectInfo().then((res) => {
				if (!res.data || res.data.status === 2) {
					remoteMethod('');
					remoteMethodSEA('');
					dutyArr.value = [];
					queryForm.value.duty = '';
					queryForm.value.subjectName = '';
					queryForm.value.subjectId = '';
					queryForm.value.studentName = '';
					queryForm.value.email = '';
					if ((store.state.user.userInfo.useSubject || store.state.user.userInfo.subjectNum !== 0) && num.value !== 0) {
						queryForm.value.userType = res.data ? Number(res.data.userType) : 1;
						isUseType.value = true;
					} else {
						// queryForm.value.subjectName = store.state.user.userInfo.useSubject;
						queryForm.value.userType = 2;
						isUseType.value = false;
					}
					isEdit.value = true;
				} else {
					if (res.data.duty && res.data.dutyIds) {
						queryForm.value.duty = res.data.duty;
						queryForm.value.dutyIds = res.data.dutyIds;
						const dutyIds = res.data.dutyIds.split(',');
						dutyArr.value = [...dutyIds];
					}
					queryForm.value.subjectId = res.data.subjectName;
					queryForm.value.studentName = res.data.studentName;
					queryForm.value.email = res.data.email;
					queryForm.value.catagory = res.data.catagory;
					isEdit.value = false;
					if (res.data.userType === '4' && (res.data.userTypeExp === '1' || res.data.userTypeExp === '2')) {
						queryForm.value.userType = Number(res.data.userType + '.' + res.data.userTypeExp);
					} else {
						queryForm.value.userType = Number(res.data.userType);
					}
				}
			});
			if (num.value === 0) {
				queryForm.value.userType = 2;
				isEdit.value = true;
			}
		}
	},
);
const loading = ref(false);
const remoteMethod = (query: string) => {
	loading.value = true;
	postStudentSubjectList({ label: query, agentType: 1 })
		.then((res) => {
			subjectList.value = res.data;
			subjectList.value.push({
				label: t('其他'),
				businessId: '-1',
			});
		})
		.finally(() => {
			loading.value = false;
		});
};
const remoteMethodSEA = (query: string) => {
	loading.value = true;
	postStudentSubjectList({ label: query, agentType: 4 })
		.then((res) => {
			subjectListSEA.value = res.data;
			subjectListSEA.value.push({
				label: t('其他SEA'),
				businessId: '-1',
			});
		})
		.finally(() => {
			loading.value = false;
		});
};
/** 是否允许编辑 */
const isEdit = ref(true);
const queryForm = ref({ userType: 1 } as {
	subjectId?: string;
	catagory?: string;
	studentName?: string;
	email: string;
	duty?: string;
	dutyIds: string;
	userType?: number;
	subjectName?: string;
});
watch(
	() => queryForm.value.userType,
	() => {
		dutyList.value = [];
		if (queryForm.value.userType === 4.1 || queryForm.value.userType === 4.2) {
			postBasePositionList(
				{},
				{
					headers: {
						'locale-language': 'en-US',
					},
				},
			).then((res) => {
				dutyList.value = res.data;
			});
		} else {
			postBasePositionList().then((res) => {
				dutyList.value = res.data;
			});
		}
	},
);
function userTypeChange() {
	queryForm.value.duty = '';
	queryForm.value.dutyIds = '';
	queryForm.value.subjectName = '';
	queryForm.value.subjectId = '';
	queryForm.value.catagory = '';
	queryForm.value.studentName = '';
	queryForm.value.email = '';
}
const saveloading = ref(false);
async function saveForm() {
	if (!queryFormRef.value) return;
	// if (
	//   queryForm.value.userType === 1 &&
	//   queryForm.value.duty === t("其他") &&
	//   !dutyStr.value
	// )
	//   return ElMessage.error(t("请填写岗位信息"));
	if (queryForm.value.userType === 1 && queryForm.value.subjectId === t('其他') && !subjectStr.value)
		return ElMessage.error(t('请填写代理商简称'));
	const duty = [] as string[];
	const dutyIds = [] as string[];
	dutyArr.value.forEach((item) => {
		let _obj = dutyList.value.find((d) => d.businessId === item);
		duty.push(_obj?.positionFmt || '');
		dutyIds.push(item);
	});
	queryForm.value.duty = duty.toString();
	queryForm.value.dutyIds = dutyIds.toString();
	await queryFormRef.value.validate((valid) => {
		if (valid) {
			saveloading.value = true;
			let data = {} as {
				subjectId?: string;
				catagory?: string;
				studentName?: string;
				email?: string;
				duty?: string;
				userType?: number;
				subjectName?: string;
				userTypeExp?: string;
			};
			if (queryForm.value.userType === 1) {
				data = { ...queryForm.value };
				data.subjectName = data.subjectId;
				if (queryForm.value.subjectId === t('其他') || queryForm.value.subjectId === t('其他SEA')) {
					data.subjectName = subjectStr.value;
				}
				delete data.subjectId;
				if (queryForm.value.duty === t('其他')) {
					data.duty = dutyStr.value;
				}
			} else if (queryForm.value.userType === 4.1 || queryForm.value.userType === 4.2) {
				data = { ...queryForm.value };
				data.subjectName = data.subjectId;
				delete data.subjectId;
				if (queryForm.value.duty === t('其他')) {
					data.duty = dutyStr.value;
				}
				let _userType = queryForm.value.userType + '';
				data.userType = 4;
				data.userTypeExp = _userType.split('.')[1];
			} else {
				data = {
					userType: queryForm.value.userType,
					subjectName: queryForm.value.subjectName,
				};
			}
			postStudentSubjectSave(data)
				.then((res) => {
					if (res.data.status === 1) {
						store.dispatch('GetInfo').finally(() => {
							store.commit('SET_INFO_PERFECT_DIALOG', false);
						});
					} else {
						store.commit('SET_INFO_PERFECT_DIALOG', false);
					}
					// store.commit("SET_USERINFO_TYPE", queryForm.value.userType);
					// if (res.data === 1) {
					//   // window.location.reload();
					//   $emits("reload");
					// } else {
					//   isEdit.value = false;
					// }
				})
				.finally(() => {
					saveloading.value = false;
				});
		}
	});
}
const queryFormRef = ref<FormInstance>();
const validatePass = (rule: any, value: any, callback: any) => {
	const emailRegex = /^[a-zA-Z0-9_+&*-]+(?:\.[a-zA-Z0-9_+&*-]+)*@(?:[a-zA-Z0-9-]+\.)+[a-zA-Z]{2,7}$/;
	if (queryForm.value.email && !emailRegex.test(queryForm.value.email)) {
		return callback(new Error('请输入正确的公司邮箱' + (queryForm.value.userType === 4 ? 'SEA' : '')));
	}
	callback();
};
const rules = computed<FormRules>(() => {
	return {
		userType: [{ required: true, message: t('请选择学员类型'), trigger: 'blur' }],
		subjectId: [
			{
				required: true,
				message: t('请输入代理商简称' + (queryForm.value.userType === 4 ? 'SEA' : '')),
				trigger: 'blur',
			},
		],
		catagory: [
			{
				required: true,
				message: 'Please select Catagory',
				trigger: 'blur',
			},
		],
		duty: [
			{
				required: true,
				message: t('请输入岗位信息' + (queryForm.value.userType === 4 ? 'SEA' : '')),
				trigger: 'blur',
			},
		],
		studentName: [
			{
				required: true,
				message: t('请输入姓名' + (queryForm.value.userType === 4 ? 'SEA' : '')),
				trigger: 'blur',
			},
		],
		subjectName: [{ required: true, message: t('请输入主体名称'), trigger: 'blur' }],
		email: [
			{
				required: true,
				message: t('请输入公司邮箱' + (queryForm.value.userType === 4 ? 'SEA' : '')),
				trigger: 'blur',
			},
			// { validator: validatePass, trigger: 'blur' },
		],
	};
});
// const changeCurrent = ref("");

// const dialogVisible = ref(false);

const subjectNum = computed(() => {
	return !store.state.user.userInfo.useType && !store.state.user.userInfo.subjectNum;
});
function beforeClose() {
	console.log('请勿关闭');
	if (!subjectNum.value) {
		ElMessageBox.confirm(t('确认关闭？信息正确完善前，您的部分功能可能受限'), t('提示'), {
			confirmButtonText: t('确定关闭'),
			cancelButtonText: t('取消'),
			type: 'info',
		})
			.then(() => {
				store.commit('SET_INFO_PERFECT_DIALOG', false);
				router.replace('/');
			})
			.catch(() => {
				// 取消
			});
	}
	return false;
}

const dialogVisible = computed(() => {

	//志成修改------
	if(route.path.indexOf('courseClockIn') > -1){  //手机打卡页不用弹窗
      return false;
    }else{
		return store.state.user.infoPerfectDialog;
	}

	//---end-----
	
});
// function save() {
//   postBaseEditStudentType({ type: changeCurrent.value })
//     .then(() => {
//       store.commit("SET_USERINFO_TYPE", changeCurrent.value);
//       dialogVisible.value = false;
//     })
//     .catch((err) => {
//       ElMessage.error(err.msg || "设置不成功，请稍后再试");
//     });
// }

return (_ctx: any,_cache: any) => {
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_form = _resolveComponent("el-form")!
  const _component_el_drawer = _resolveComponent("el-drawer")!

  return (_openBlock(), _createBlock(_component_el_drawer, {
    modelValue: _unref(dialogVisible),
    "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (_isRef(dialogVisible) ? (dialogVisible).value = $event : null)),
    "before-close": beforeClose,
    size: "100%",
    lockScroll: false,
    "show-close": !_unref(subjectNum)
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_el_form, {
          ref_key: "queryFormRef",
          ref: queryFormRef,
          rules: _unref(rules),
          model: queryForm.value,
          size: "default",
          disabled: !isEdit.value,
          "label-width": "128px",
          onSubmit: _cache[11] || (_cache[11] = _withModifiers(() => {}, ["prevent"]))
        }, {
          default: _withCtx(() => [
            (isUseType.value)
              ? (_openBlock(), _createBlock(_component_el_form_item, {
                  key: 0,
                  label: "",
                  "label-width": "0"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("span", _hoisted_2, _toDisplayString(_ctx.$t(
								'此课程为代理合作伙伴定制,非代理商身份无使用权限。如果您有疑问,请通过人工客服联系我们,我们将为您提供进一步的帮助。' +
									(queryForm.value.userType === 4.1 || queryForm.value.userType === 4.2 ? 'SEA' : ''),
							)), 1)
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_el_form_item, {
              label: _ctx.$t('学员类型' + (queryForm.value.userType === 4.1 || queryForm.value.userType === 4.2 ? 'SEA' : '')),
              prop: "userType"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_radio_group, {
                  modelValue: queryForm.value.userType,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((queryForm.value.userType) = $event)),
                  class: "ml-4",
                  onChange: _cache[1] || (_cache[1] = ($event: any) => (userTypeChange()))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_radio, { value: 1 }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('中国跨境代理商' + (queryForm.value.userType === 4.1 || queryForm.value.userType === 4.2 ? 'SEA' : ''))), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_radio, {
                      value: 2,
                      disabled: num.value === 0 || isUseType.value
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('中国跨境商家' + (queryForm.value.userType === 4.1 || queryForm.value.userType === 4.2 ? 'SEA' : ''))), 1)
                      ]),
                      _: 1
                    }, 8, ["disabled"]),
                    _createVNode(_component_el_radio, { value: 4.1 }, {
                      default: _withCtx(() => [
                        _createTextVNode("SEA Agency-Star Camp")
                      ]),
                      _: 1
                    }, 8, ["value"]),
                    _createVNode(_component_el_radio, { value: 4.2 }, {
                      default: _withCtx(() => [
                        _createTextVNode("SEA Agency-Others")
                      ]),
                      _: 1
                    }, 8, ["value"])
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            }, 8, ["label"]),
            (queryForm.value.userType === 1)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createVNode(_component_el_form_item, {
                    label: _ctx.$t('代理商简称'),
                    prop: "subjectId"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        modelValue: queryForm.value.subjectId,
                        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((queryForm.value.subjectId) = $event)),
                        filterable: "",
                        remote: "",
                        loading: loading.value,
                        "remote-method": remoteMethod,
                        placeholder: _ctx.$t('请选择代理商，可通过关键字查询，如没有检索结果请选择其他选项')
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(subjectList.value, (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              class: "option-width",
                              key: item.businessId,
                              label: item.label,
                              value: item.label
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue", "loading", "placeholder"])
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  (queryForm.value.subjectId === _ctx.$t('其他'))
                    ? (_openBlock(), _createBlock(_component_el_form_item, {
                        key: 0,
                        label: " "
                      }, {
                        default: _withCtx(() => [
                          _createVNode(_component_el_input, {
                            modelValue: subjectStr.value,
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((subjectStr).value = $event)),
                            modelModifiers: { trim: true },
                            maxlength: "200",
                            "show-word-limit": "",
                            placeholder: _ctx.$t('请输入代理商简称')
                          }, null, 8, ["modelValue", "placeholder"])
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  _createVNode(_component_el_form_item, {
                    label: _ctx.$t('姓名'),
                    prop: "studentName"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: queryForm.value.studentName,
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((queryForm.value.studentName) = $event)),
                        modelModifiers: { trim: true },
                        maxlength: "50",
                        "show-word-limit": "",
                        placeholder: _ctx.$t('请输入姓名（请填写你在公司的真实姓名）')
                      }, null, 8, ["modelValue", "placeholder"])
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  _createVNode(_component_el_form_item, {
                    label: _ctx.$t('岗位'),
                    prop: "duty"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_select, {
                        modelValue: dutyArr.value,
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((dutyArr).value = $event)),
                        multiple: "",
                        "collapse-tags-tooltip": "",
                        placeholder: _ctx.$t('请选择岗位信息')
                      }, {
                        default: _withCtx(() => [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(dutyList.value, (item) => {
                            return (_openBlock(), _createBlock(_component_el_option, {
                              class: "option-width",
                              key: item.businessId,
                              label: item.positionFmt,
                              value: item.businessId
                            }, null, 8, ["label", "value"]))
                          }), 128))
                        ]),
                        _: 1
                      }, 8, ["modelValue", "placeholder"])
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  _createVNode(_component_el_form_item, {
                    label: _ctx.$t('公司邮箱'),
                    prop: "email"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: queryForm.value.email,
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((queryForm.value.email) = $event)),
                        modelModifiers: { trim: true },
                        maxlength: "100",
                        "show-word-limit": "",
                        placeholder: _ctx.$t('请输入公司邮箱')
                      }, null, 8, ["modelValue", "placeholder"])
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  _createVNode(_component_el_form_item, { label: "" }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", _hoisted_3, [
                        _createTextVNode(_toDisplayString(_ctx.$t('提示: 提交成功后,请耐心等待管理员审核.')), 1),
                        _hoisted_4,
                        _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.$t('剩余审核次数:N次', { text: num.value })), 1)
                      ])
                    ]),
                    _: 1
                  })
                ], 64))
              : _createCommentVNode("", true),
            (queryForm.value.userType === 2)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                  _createVNode(_component_el_form_item, {
                    label: _ctx.$t('主体名称'),
                    prop: "subjectName"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: queryForm.value.subjectName,
                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((queryForm.value.subjectName) = $event)),
                        modelModifiers: { trim: true },
                        maxlength: "50",
                        "show-word-limit": "",
                        placeholder: _ctx.$t('请输入主体名称')
                      }, null, 8, ["modelValue", "placeholder"])
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  _createVNode(_component_el_form_item, { label: "" }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.$t('请准确填写您的开户主体信息。若信息偏差较大，我们将再次向您进行确认。')), 1)
                    ]),
                    _: 1
                  })
                ], 64))
              : _createCommentVNode("", true),
            (queryForm.value.userType === 4.1 || queryForm.value.userType === 4.2)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
                  _createVNode(_component_el_form_item, {
                    label: _ctx.$t('代理商简称SEA'),
                    prop: "subjectId"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: queryForm.value.subjectId,
                        "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((queryForm.value.subjectId) = $event)),
                        modelModifiers: { trim: true },
                        maxlength: "200",
                        "show-word-limit": "",
                        placeholder: _ctx.$t('请输入代理商简称SEA')
                      }, null, 8, ["modelValue", "placeholder"])
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  _createVNode(_component_el_form_item, {
                    label: _ctx.$t('姓名SEA'),
                    prop: "studentName"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: queryForm.value.studentName,
                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((queryForm.value.studentName) = $event)),
                        modelModifiers: { trim: true },
                        maxlength: "50",
                        "show-word-limit": "",
                        placeholder: _ctx.$t('请输入姓名（请填写你在公司的真实姓名）SEA')
                      }, null, 8, ["modelValue", "placeholder"])
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  _createVNode(_component_el_form_item, {
                    label: _ctx.$t('公司邮箱SEA'),
                    prop: "email"
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_el_input, {
                        modelValue: queryForm.value.email,
                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((queryForm.value.email) = $event)),
                        modelModifiers: { trim: true },
                        maxlength: "100",
                        "show-word-limit": "",
                        placeholder: _ctx.$t('请输入公司邮箱SEA')
                      }, null, 8, ["modelValue", "placeholder"])
                    ]),
                    _: 1
                  }, 8, ["label"]),
                  _createVNode(_component_el_form_item, {
                    label: "",
                    "label-width": "0px"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", _hoisted_7, [
                        _createTextVNode(_toDisplayString(_ctx.$t('提示: 提交成功后,请耐心等待管理员审核.SEA')), 1),
                        _hoisted_8,
                        _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.$t('剩余审核次数:N次SEA', { text: num.value })), 1)
                      ])
                    ]),
                    _: 1
                  })
                ], 64))
              : _createCommentVNode("", true),
            _createVNode(_component_el_form_item, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_button, {
                  type: "primary",
                  size: "large",
                  round: "",
                  color: "#fe2c55",
                  class: "min-width-200",
                  loading: saveloading.value,
                  onClick: saveForm
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(isEdit.value
						? _ctx.$t('提交' + (queryForm.value.userType === 4.1 || queryForm.value.userType === 4.2 ? 'SEA' : ''))
						: _ctx.$t('待审核' + (queryForm.value.userType === 4.1 || queryForm.value.userType === 4.2 ? 'SEA' : ''))), 1)
                  ]),
                  _: 1
                }, 8, ["loading"])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["rules", "model", "disabled"])
      ])
    ]),
    _: 1
  }, 8, ["modelValue", "show-close"]))
}
}

})